import { render, staticRenderFns } from "./setFontConfig.vue?vue&type=template&id=d336faa2&"
import script from "./setFontConfig.vue?vue&type=script&lang=js&"
export * from "./setFontConfig.vue?vue&type=script&lang=js&"
import style0 from "./setFontConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports